import { fork, take, put, select, call, race } from 'redux-saga/effects';
import { takeLatest, delay } from 'redux-saga';

import * as api from 'api';
import * as actions from 'actions';
import { optimisticUpdateMaker } from 'utils/sagas';
import { getUserProfile } from 'selectors';

const update = optimisticUpdateMaker({
  idKey: 'goalId',
  localUpdateType: actions.GOAL_UPDATE,
  successType: actions.GOAL_CHANGE_SCORE_SUCCESS,
  errorType: actions.GOAL_CHANGE_SCORE_ERROR,
  remoteUpdateActionCreator: function* (localUpdateAction) {
    if(localUpdateAction.updates.score !== undefined) {
      return actions.goalChangeScore(localUpdateAction.goalId, localUpdateAction.updates.score, localUpdateAction.source);
    }
  },
  localUpdateActionCreator: function* (lastRemoteState, errorAction) {
    return actions.goalUpdate(errorAction.goalId, null, lastRemoteState);
  }
});

export function* watchForGoalCreateSuccess() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.GOAL_CREATE_SUCCESS);
    const { successTitle, successMessage } = action;

    const profile = yield select(getUserProfile);
    const infoBarTitle = profile.userName ? `${successTitle} ${profile.userName}!` : successTitle;
    yield put(actions.infoShow('success', successMessage, infoBarTitle));

    const { timeout, cancelAction } = yield race({ // eslint-disable-line no-unused-vars
      timeout: call(delay, process.env.KOOTH_INFOBAR_AUTOHIDE_DELAY),
      cancelAction: take(actions.INFO_CLOSE)
    });

    if(timeout) {
      yield put(actions.infoClose('success'));
    }
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(update),
    fork(takeLatest, actions.GOALS_FETCH, request(api.goalsFetch, 'query')),
    fork(takeLatest, actions.GOAL_CHANGE_SCORE, request(api.goalChangeScore, 'goalId', 'score', 'source')),
    fork(takeLatest, actions.GOAL_CREATE, request(api.goalCreate, 'goal', 'source')),
    fork(watchForGoalCreateSuccess)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/goals/sagas.js
 **/